import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import type { ScenarioState } from '../model/scenario.slice';

type TCreditSelectionContent = ContentOfType<SCENARIO_STEP.CREDIT_SELECTION>;
type TScenarioSection = TCreditSelectionContent['sections'][number];
type TOnlineGroupSection = Extract<TScenarioSection, { type: 'onlineGroup' }>;
type TOnlineGroupElements = TOnlineGroupSection['elements'];

export const updateOnlineGroupElements = (state: ScenarioState, elements: TOnlineGroupElements) => {
  const content = state.currentStep?.content as TCreditSelectionContent | undefined;

  if (!content?.sections) {
    return;
  }

  content?.sections.forEach((section) => {
    if (section.type === 'onlineGroup') {
      section.elements = elements;
    }
  });
};
